import { ISelectItem } from "@/types";
import {
  IProgress,
  IProgressRequest,
  IProgressUpdateRequest,
} from "@/types/progress";
import { ISales } from "@/types/sales";
import { Sales } from "./sales";

export class Progress implements IProgress {
  public id = 0;
  public company_id = 0;
  public is_completed = false;
  public name = "";
  public created_at = "";
  public updated_at = "";

  public sales = new Sales();

  public constructor(props?: IProgress) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
    if (props.sales) {
      this.sales = new Sales(props.sales);
    }
  }

  public static toSelectItem(proceed: IProgress): ISelectItem {
    return {
      text: proceed.name,
      value: proceed.id,
    };
  }
}

export class ProgressRequest implements IProgressRequest {
  public is_completed = false;
  [key: string]: unknown;

  public constructor(props?: IProgress) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }
}

// export class ProgressCreateRequest
//   extends ProgressRequest
//   implements IProgressCreateRequest {}

export class ProgressUpdateRequest
  extends ProgressRequest
  implements IProgressUpdateRequest {}
